export default {
  // 路由国际化
  route: {
    dashboard: "首页",
    document: "项目文档",
    system: "系统管理",
    user: "用户管理",
    role: "角色管理",
    menu: "菜单管理",
    dict: "字典管理",
    dept: "部门管理",
    reporting: "汇报管理",
    weekly: "周报管理",
    dailySpecial: "日报专用",
    daily: "日报管理",
    workReport: "工作汇报",
    meeting: "会议管理",
    reportMessages: "汇报消息",
    notice: "通知公告",
    finance: "财务管理",
    reserves: "备用金",
    borrow: "借款",
    reimbursement: "报销",
    documents: "重要文件",
    expenses: "费用收支",
    contract: "合同管理",
    statements: "财务报表",
    invoice: "发票管理",
    personnel: "人事管理",
    dimission: "离职管理",
    regularization: "转正管理",
    performance: "绩效考核",
    emp: "员工管理",
    positions: "职位管理",
    customer: "客户管理",
    customerLists: "客户列表",
    disuseCustomers: "废弃客户",
    followUpRecords: "跟进记录",
    wflow: "工作流",
    design: "流程管理",
    approvalList: "审批列表",
    myApplication: "我发起的",
    carbonCopy: "抄送我的",
    myPending: "待我处理",
    myProcessed: "已处理的",
    admin: "创建表单",
    administrative: "行政管理",
    documentation: "文档管理",
    development: "开发管理",
    workorder: "工单管理",
    ticketAll: "所有工单",
    myCreate: "我的创建",
    ticketlist: "我的待办",
    createticket: "创建工单",
    processingticket: "工单详情",
    netdisc: "企业网盘",
    settings: "网盘管理",
    myFiles: "我的文件",
    profile: "个人中心",
    findAllNotice: "全部公告",
    expenseschart: "收支图表",
  },
  404: {
    home: "返回首页",
  },
  // 登录页面国际化
  login: {
    username: "用户名",
    password: "密码",
    login: "登 录",
    captchaCode: "验证码",
    capsLock: "大写锁定已打开",
    userRegistration: "用户注册",
    forgotPassword: "忘记密码",
    confirmPassword: "确认密码",
    enterEmail: "请输入邮箱",
    sendEmailCode: "发送邮箱验证码",
    register: "注 册",
    userLogin: "用户登入",
    nextStep: "下一步",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    second: "秒",
    enterUsername: "请输入用户名",
    enterPassword: "请输入密码",
    passwordTooShort: "密码不能少于6位",
    enterVerificationCode: "请输入验证码",
    enterYourEmail: "请输入您的电子邮件",
    enterValidEmail: "请输入有效的电子邮件地址",
    repeatPasswordRequired: "重复密码不能为空！",
    passwordsDoNotMatch: "两次输入密码不一致！",
    emailSent: "邮件已发送，请注意查收",
    registrationSuccess: "注册成功",
    usernameExists: "该用户名已存在",
    passwordResetSuccess: "密码重置成功",
  },
  dashboard: {
    initiateNotification: "发起通知",
    processWorkflow: "流程处理",
    announcementNotification: "公告通知",
    more: "更多",
    noAnnouncements: "暂无公告通知",
    dailyReport: "日报",
    dailyReportOnly: "日报专用",
    weeklyReport: "周报",
    workReport: "工作汇报",
    expenseIncome: "费用收支",
    meetingSummary: "会议总结",
    morningPoem: "晨起披衣出草堂，轩窗已自喜微凉🌅！",
    goodMorning: "上午好，{name}！",
    goodAfternoon: "下午好，{name}！",
    goodEvening: "晚上好，{name}！",
    goodNightPoem:
      "偷偷向银河要了一把碎星，只等你闭上眼睛撒入你的梦中，晚安🌛！",
    clickToDownload: "点击下载",
    unfinishedNotification: "未完成通知",
    urgentReminder: "紧急提醒",
    completed: "已完成",
    annual: "年度统计",
    income: "收入",
    expense: "支出",
    monthlyStatistics: "月度统计",
    monthName: "月份",
    paymentCategoryStatistics: "支付分类统计",
    selectTimeRange: "选择时间段",
    firstHalfOfYear: "{currentYear}年上半年",
    secondHalfOfYear: "{currentYear}年下半年",
    wechat: "微信",
    corporateAccount: "公户",
    creditCard: "信用卡",
    alipay: "支付宝",
    announcementTitle: "公告标题",
    enterAnnouncementTitle: "请输入公告标题",
    announcementType: "公告类型",
    selectAnnouncementType: "请选择公告类型",
    publisher: "发布人",
    publishTime: "发布时间",
    status: "状态",
    enabled: "正常",
    disabled: "禁用",
    assignedDepartment: "指定部门",
    selectDepartment: "请选择部门",
    content: "内容",
    enterContent: "请输入内容",
    announcementDetails: "公告详情",
    quarterlyStatistics: "季度统计",
    firstQuarter: "第一季度",
    secondQuarter: "第二季度",
    thirdQuarter: "第三季度",
    fourthQuarter: "第四季度",
  },
  profile: {
    personalInfo: "个人信息",
    username: "用户名称",
    phoneNumber: "手机号码",
    email: "用户邮箱",
    department: "所属部门",
    role: "所属角色",
    createdAt: "创建日期",
    basicProfile: "基本资料",
    changePassword: "修改密码",
    oldPassword: "旧密码",
    enterOldPassword: "请输入旧密码",
    newPassword: "新密码",
    enterNewPassword: "请输入新密码",
    confirmPassword: "确认密码",
    enterConfirmPassword: "请确认新密码",
    save: "保存",
    close: "关闭",
    passwordMismatch: "两次输入的密码不一致",
    newSameAsOld: "新密码不能与旧密码相同",
    oldPasswordRequired: "旧密码不能为空",
    newPasswordRequired: "新密码不能为空",
    passwordLengthLimit: "长度在 6 到 20 个字符",
    invalidCharacters: "不能包含非法字符：< > \\\" ' \\\\ |",
    confirmPasswordRequired: "确认密码不能为空",
    passwordChangeSuccess: "密码修改成功，请重新登录",
    nickname: "用户昵称",
    gender: "性别",
    male: "男",
    female: "女",
    nicknameRequired: "用户昵称不能为空",
    emailRequired: "邮箱地址不能为空",
    invalidEmail: "请输入正确的邮箱地址",
    phoneRequired: "手机号码不能为空",
    invalidPhone: "请输入正确的手机号码",
    updateSuccess: "修改成功",
    updateFailed: "更新用户信息失败: {0}",
    uploadAvatar: "点击上传头像",
    choose: "选择",
    submit: "提交",
    invalidFileFormat: "文件格式错误，请上传图片。",
    fileTooLarge: "文件过大，请上传小于5MB的图片。",
    avatarUpdateSuccess: "头像修改成功",
    avatarUpdateFailed: "头像修改失败",
    retryAvatarUpdate: "修改头像失败，请重试",
    cropFailed: "无法获取裁剪后的图片",
  },
  // 导航栏国际化
  navbar: {
    dashboard: "首页",
    logout: "注销登出",
    document: "项目文档",
    gitee: "项目地址",
    personalCenter: "个人中心",
  },
  sizeSelect: {
    tooltip: "布局大小",
    default: "默认",
    large: "大型",
    small: "小型",
    message: {
      success: "切换布局大小成功！",
    },
  },
  langSelect: {
    message: {
      success: "切换语言成功！",
    },
  },
  settings: {
    project: "项目配置",
    theme: "主题设置",
    interface: "界面设置",
    navigation: "导航设置",
    themeColor: "主题颜色",
    tagsView: "开启 Tags-View",
    fixedHeader: "固定 Header",
    sidebarLogo: "侧边栏 Logo",
    watermark: "开启水印",
    leftMode: "左侧模式",
    topMode: "顶部模式",
    mixedMode: "混合模式",
  },
  positions: {
    message: {
      successDelete: "删除成功",
      editSuccess: "修改成功",
      addSuccess: "新增职位成功",
    },
  },
  dept: {
    keyword: "关键字",
    departmentName: "部门名称",
    departmentStatus: "部门状态",
    all: "全部",
    active: "正常",
    inactive: "禁用",
    reset: "重置",
    search: "搜索",
    add: "新增",
    delete: "删除",
    positionNum: "职位编号",
    status: "状态",
    displayOrder: "显示顺序",
    sort: "排序",
    operate: "操作",
    edit: "编辑",
    editJobInfo: "修改职位信息",
    newPosition: "新增职位",
    enterJobTitlePlaceholder: "请输入职位名称",
    superiorDepartment: "上级部门",
    selectSuperiorDepartment: "选择上级部门",
    pleaseEnterDepartmentName: "请输入部门名称",
    showSort: "显示排序",
    confirm: "确定",
    cancel: "取消",
    message: {
      jobTitle: {
        required: "职位名称不能为空",
      },
      dept: {
        required: "所属部门不能为空",
      },
      parentId: {
        required: "上级部门不能为空",
      },
      name: {
        required: "部门名称不能为空",
      },
      sort: {
        required: "显示排序不能为空",
      },
      remove: {
        check: "请勾选删除项",
        warn: "警告",
        confirm: "确认删除职位?",
        successDelete: "删除成功",
      },
    },
    topDept: "顶级部门",
    modifyDept: "修改部门",
    newDept: "新增部门",
    successModify: "修改成功",
    addSuccess: "新增职位成功",
    Confirm_selected_data_items: "确认删除已选中的数据项",
    departmentHead: "部门负责人",
    selectDepartmentHead: "请选择部门负责人",
    departmentHeadRequired: "部门负责人不能为空",
  },
  role: {
    keyword: "关键字",
    roleName: "角色名称",
    reset: "重置",
    search: "搜索",
    new: "新增",
    delete: "删除",
    roleCoding: "角色编码",
    normal: "正常",
    disable: "禁用",
    status: "状态",
    sort: "排序",
    operate: "操作",
    assignPermissions: "分配权限",
    edit: "编辑",
    dataPermission: "数据权限",
    allData: "全部数据",
    departmentData: "部门及子部门数据",
    Data_this_department: "本部门数据",
    Personal_data: "本人数据",
    confirm: "确定",
    cancel: "取消",
    modifyRole: "修改角色",
    newRole: "新增角色",
    deactivate: "停用",
    message: {
      name: {
        placeholder: "请输入角色名称",
        required: "角色名称不能为空",
      },
      code: {
        placeholder: "请输入角色编码",
        required: "角色编码不能为空",
      },
      dataScope: {
        placeholder: "请选择数据权限",
        required: "数据权限不能为空",
      },
      status: {
        required: "请选择状态",
      },
      remove: {
        check: "请勾选删除项",
        warn: "警告",
        successDelete: "删除成功",
      },
    },
    successModify: "修改成功",
    addSuccessfully: "新增成功",
    Confirm_selected_data_items: "确认删除已选中的数据项",
    Permissions_assigned_successfully: "分配权限成功",
  },
  NavbarRight: {
    Are_you_sure_system: "您确定要注销并退出系统吗",
    confirm: "确定",
    cancel: "取消",
    prompt: "提示",
  },
  user: {
    departmentName: "部门名称",
    keyword: "关键字",
    keywordValue: "用户名/昵称/手机号",
    status: "状态",
    all: "全部",
    creationTime: "创建时间",
    startTime: "开始时间",
    endTime: "截至时间",
    enable: "启用",
    disable: "禁用",
    search: "搜索",
    reset: "重置",
    new: "新增",
    delete: "删除",
    import: "导入",
    downloadTemplate: "下载模板",
    importData: "导入数据",
    export: "导出",
    edit: "编辑",
    resetPassword: "重置密码",
    operate: "操作",
    tel: "手机号码",
    jobTitle: "岗位名称",
    department: "部门",
    id: "编号",
    username: "用户名",
    nickname: "用户昵称",
    gender: "性别",
    message: {
      username: {
        required: "请输入用户名",
      },
      nickname: {
        required: "请输入用户昵称",
      },
      department: {
        required: "请选择所属部门",
      },
      pleaseSelect: {
        required: "请选择",
      },
      tel: {
        required: "请输入手机号码",
      },
      email: {
        required: "请输入邮箱",
      },
      rules: {
        username: "用户名不能为空",
        nickname: "用户昵称不能为空",
        deptId: "所属部门不能为空",
        roleIds: "用户角色不能为空",
        email: "请输入正确的邮箱地址",
        tel: "请输入正确的手机号码",
      },
      password: {
        notallow: "您只能修改自己的密码！",
        user: "请输入用户「",
        newPassword: "」的新密码",
        error: "密码长度不能小于6位",
        inputNewPassword: "请输入新密码",
        resetSuccessful: "密码重置成功，新密码是：",
      },
      userForm: {
        modifyUser: "修改用户",
        addUser: "新增用户",
        importUsers: "导入用户",
        modification: "修改用户成功",
        addition: "新增用户成功",
      },
      userImport: {
        department: "请选择部门",
        excel: "上传Excel文件不能为空",
        import: "导入用户成功",
      },
      remove: {
        check: "请勾选删除项",
        deletion: "确认删除用户？",
        warn: "警告",
        successDelete: "删除成功",
      },
    },
    role: "角色",
    email: "邮箱",
    normal: "正常",
    execl: "Excel文件",
    dragFilesHere: "将文件拖到此处，或",
    upload: "点击上传",
    confirm: "确 定",
    cancel: "取 消",
  },
  menu: {
    keyword: "关键字",
    search: "搜索",
    reset: "重置",
    new: "新增",
    status: "状态",
    sort: "排序",
    operate: "操作",
    edit: "编辑",
    delete: "删除",
    confirm: "确 定",
    cancel: "取 消",
    successModify: "修改成功",
    addSuccessfully: "新增成功",
    message: {
      remove: {
        check: "请勾选删除项",
        warn: "警告",
        successDelete: "删除成功",
      },
    },
    Confirm_selected_data_items: "确认删除已选中的数据项？",
    deletion: "已取消删除",
    menuTitle: "菜单名称",
    type: "类型",
    directory: "目录",
    menu: "菜单",
    button: "按钮",
    link: "外链",
    show: "显示",
    hide: "隐藏",
    parentMenu: "父级菜单",
    selectParentMenu: "选择上级菜单",
    enterMenuName: "请输入菜单名称",
    menuType: "菜单类型",
    linkAddress: "外链地址",
    linkURL: "请输入外链完整路径",
    routePath: "路由路径",
    componentPath: "组件路径",
    permissionIdentifier: "权限标识",
    yes: "是",
    no: "否",
    cacheEnabled: "是否缓存",
    displayRoot: "根目录始终显示",
    yesRoot: "是：根目录只有一个子路由显示目录",
    noRoot: "否：根目录只有一个子路由不显示目录，只显示子路由",
    pagePath: "页面路径",
    displayStatus: "显示状态",
    icon: "图标",
    redirectRoute: "跳转路由",
    top_levelMenu: "顶级菜单",
    editMenu: "编辑菜单",
    addMenu: "新增菜单",
    rules: {
      parentId: "请选择顶级菜单",
      name: "请输入菜单名称",
      type: "请选择菜单类型",
      path: "请输入路由路径",
      link: "请输入完整的外部链接",
      component: "请输入组件路径",
    },
    clickToSelectIcon: "点击选择图标",
    searchIcon: "搜索图标",
  },
  dict: {
    keyword: "关键字",
    search: "搜索",
    reset: "重置",
    new: "新增",
    delete: "删除",
    dictionaryTypeNameOrCode: "字典类型名称/编码",
    dictionaryTypeName: "字典类型名称",
    dictionaryTypeCode: "字典类型编码",
    status: "状态",
    remarks: "备注",
    actions: "操作",
    enabled: "启用",
    disabled: "禁用",
    dictionaryData: "字典数据",
    edit: "编辑",
    editDictionaryType: "修改字典类型",
    addDictionaryType: "新增字典类型",
    dictionaryName: "字典名称",
    dictionaryCode: "字典编码",
    enterDictionaryName: "请输入字典名称",
    enterDictionaryCode: "请输入字典编码",
    normal: "正常",
    inactive: "停用",
    dictionaryTypeRemarks: "字典类型备注",
    confirm: "确 定",
    cancel: "取 消",
    enterDictionaryTypeName: "请输入字典类型名称",
    enterDictionaryTypeCode: "请输入字典类型编码",
    editSuccess: "修改成功",
    addSuccess: "新增成功",
    selectItemsToDelete: "请勾选删除项",
    confirmDeleteSelected: "确认删除已选中的数据项?",
    warning: "警告",
    deleteSuccess: "删除成功",
    dictionaryValue: "字典值",
    sortOrder: "排序",
    tagType: "标签类型",
    clear: "清空",
    enterDictionaryValue: "请输入字典值",
    editDictionary: "修改字典",
    addDictionary: "新增字典",
  },
  design: {
    createForm: "新建表单",
    createGroup: "新建分组",
    dragSortForms: "分组内表单流程可拖拽排序，拖拽分组名右侧",
    dragSortGroups: "可对分组排序",
    edit: "修改",
    delete: "删除",
    updatedAt: "更新于:",
    editItem: "编辑",
    deactivate: "停用",
    activate: "启用",
    submit: "提交",
    move: "移动",
    addGroup: "新增分组",
    addGroupSuccess: "新增分组成功",
    inputGroupNameToAdd: "请输入要添加的组名",
    cancel: "取消",
    confirm: "确定",
    editGroup: "修改分组",
    groupEditSuccess: "修改分组成功",
    inputNewGroupName: "请输入新的组名",
    inputGroupName: "请输入分组名",
    emptyGroupName: "分组名不能为空",
    confirmEnable: "激活表单",
    confirmEnableForm: "确定要启用？",
    confirmDisable: "禁用表单",
    confirmDisableForm: "确定要停用？",
    enableSuccess: "启用流程成功",
    disableSuccess: "停用流程成功",
    selectGroup: "请选择分组",
    moveToGroupSuccess: "移动到新分组成功",
    deleteSuccess: "删除成功",
    deleteGroupSuccess: "删除分组成功",
    sortSuccess: "排序成功",
    deleteForm: "删除表单",
    confirmDeleteForm: "您确定要删除此表单吗？",
    deleteGroup: "删除分组",
    confirmDeleteGroup: "确定要删除该分组吗？",
  },
  notice: {
    keyword: "关键字",
    announcementTitle: "公告标题",
    enterAnnouncementTitle: "请输入公告标题",
    announcementType: "公告类型",
    search: "搜索",
    reset: "重置",
    add: "新增",
    delete: "删除",
    index: "序号",
    assignedDepartment: "指定部门",
    status: "状态",
    active: "正常",
    inactive: "禁用",
    createdBy: "创建者",
    createdAt: "创建时间",
    actions: "操作",
    edit: "修改",
    view: "查看",
    selectAnnouncementType: "请选择公告类型",
    publisher: "发布人",
    publishedAt: "发布时间",
    selectDepartment: "请选择部门",
    content: "内容",
    enterContent: "请输入内容",
    confirm: "确 定",
    cancel: "取 消",
    titleRequired: "公告标题不能为空",
    typeRequired: "公告类型不能为空",
    departmentRequired: "指定部门不能为空",
    addAnnouncement: "添加公告",
    details: "详情",
    editAnnouncement: "修改公告",
    editSuccess: "修改成功",
    addSuccess: "新增成功",
    formValidationFailed: "表单验证失败：",
    confirmDeleteMessage: '是否确认删除公告编号为"',
    confirmDeleteSuffix: '"的数据项？',
    prompt: "提示",
    deleteSuccess: "删除成功",
    announcementDetails: "公告详情",
  },
  workflow: {
    cancel: "取消",
    submit: "提交",
    submitSuccess: "提交成功",
    formCreateSuccess: "发布成功",
    formEditSuccess: "修改成功",
    completeSteps: "请完善流程选项!",
    initiate: "发起",
    approvalType: "审批类型",
    initiator: "发起人",
    currentStep: "当前节点",
    submittedAt: "提交时间",
    endedAt: "结束时间",
    approvalStatus: "审批状态",
    duration: "已耗时",
    inProgress: "审批进行中",
    withdrawn: "审批被撤回",
    rejected: "审批被驳回",
    approved: "审批通过",
    flowNotEnded: "流程进行中尚未结束",
    timeFull: "{0}年{1}月{2}天{3}小时{4}分钟{5}秒",
    timeNoYears: "{0}月{1}天{2}小时{3}分钟{4}秒",
    timeNoMonths: "{0}天{1}小时{2}分钟{3}秒",
    timeNoDays: "{0}小时{1}分钟{2}秒",
    timeNoHours: "{0}分钟{1}秒",
    timeOnlySeconds: "{0}秒",
    processingTime: "处理耗时",
  },
  workorder: {
    ticketTitle: "工单标题",
    ticketTitlePlaceholder: "请输入工单标题",
    department: "选择部门",
    departmentPlaceholder: "请选择所属部门",
    user: "选择用户",
    selectUser: "请选择用户",
    userPlaceholder: "请选择所属部门下的用户",
    priority: "优先级",
    type: "类型",
    ticketType: "工单类型",
    ticketDescription: "工单描述",
    description: "问题描述",
    descriptionPlaceholder: "请输入工单问题描述",
    submit: "提交",
    validateTitle: "请输入工单标题",
    validatePriority: "请选择工单优先级",
    validateType: "请选择工单类型",
    validateDepartment: "请选择所属部门",
    createSuccess: "创建工单成功",
    select: "请选择",
    search: "搜索",
    reset: "重置",
    id: "编号ID",
    title: "标题",
    status: "当前状态",
    creator: "发起人",
    selectHandler: "请选择处理人",
    currentAssignee: "当前处理人",
    solutionLog: "解决方案记录",
    assignee: "处理人",
    assignedBy: "分配者姓名",
    assigneeName: "被分配者姓名",
    assignmentTime: "分配时间",
    createdAt: "创建时间",
    updatedAt: "更新时间",
    ticketDetail: "工单详情",
    basicInfo: "基础信息",
    formInfo: "表单信息",
    actionHistory: "历史操作记录详情",
    performedBy: "操作用户名",
    actionType: "操作类型",
    timestamp: "操作时间",
    actionDescription: "操作描述",
    assignmentHistory: "分配记录详情",
    accept: "接受",
    assign: "分配",
    rollback: "回退",
    complete: "完成",
    edit: "修改",
    delete: "删除",
    reject: "拒单",
    urge: "催单",
    assignReason: "分配原因",
    assignReasonPlaceholder: "请输入分配原因",
    confirm: "确定",
    cancel: "取消",
    requester: "请求者",
    requesterPlaceholder: "请选择请求人",
    statusLabel: "状态",
    confirmAccept: "确认接受此工单?",
    acceptConfirm: "确认接受",
    acceptedSuccess: "成功接受工单",
    confirmRollback: "确定要回退吗？",
    rollbackConfirm: "确认回退",
    rollbackReason: "回退原因",
    rollbackReasonPlaceholder: "请输入回退原因",
    rollbackEmpty: "回退原因不能为空",
    rollbackSuccess: "回退成功",
    resolution: "解决方法",
    resolutionPlaceholder: "请输入解决方法",
    resolutionEmpty: "解决方法不能为空",
    confirmComplete: "确定要完成此操作吗?\n 解决方法: {resolution}",
    completeConfirm: "确认完成",
    completeSuccess: "完成成功",
    assignSuccess: "分配成功",
    urgeTooSoon: "请稍等一分钟后再进行催单操作",
    urgeAcceptPrompt: "是否催促处理人尽快接受此工单?",
    urgeCompletePrompt: "是否催促处理人尽快完成此工单?",
    warning: "警告",
    urgeSent: "已发送催单通知给处理人",
    inputTitle: "请输入标题",
    inputDescription: "请输入描述",
    inputType: "请输入类型",
    inputPriority: "请输入优先级",
    inputCreatedTime: "请输入创建时间",
    inputUpdatedTime: "请输入更新时间",
    updateSuccess: "更新成功",
    confirmBatchDelete: "确认要删除选中的工单",
    confirmDelete: "确定要删除此工单吗？",
    deleteSuccess: "删除成功",
    description1: "描述",
    ticketEdit: "工单修改",
    ticketAssign: "工单分配",
  },
  wdrawer: {
    approvalDetails: "审批详情",
    idLabel: "编号：",
    notSelected: "未选择",
    star: "星",
    zeroStar: "0 星",
    to: "至",
    durationLabel: "时长：",
    participateComment: "参与评论",
    inProgress: "进行中",
    signatureLabel: "签字：",
    approvalInProgress: "审批进行中",
    initiatedByMe: "我发起的",
    revoke: "撤销",
    pendingMyAction: "待我处理",
    approve: "同意",
    reject: "驳回",
    ccToMe: "抄送我的",
    comment: "评论",
    processed: "已处理的",
    printPreview: "打印预览",
    approvalId: "审批编号：",
    submittedAt: "提交时间：",
    applicant: "申请人",
    approvalFlow: "审批流程",
    approvedAlready: "已同意",
    approvalResult: "审批结果",
    approvalPassed: "审批通过",
    printedBy: "打印人：",
    printedAt: "打印时间：",
    cancel: "取 消",
    print: "打印",
    withdrawn: "审批被撤回",
    rejected: "审批被驳回",
    approved: "审批通过",
    noDateTimeRangeComponent: "未找到日期时间区间组件",
    noDateTimeRangeProvided: "没有填写日期时间区间",
    zeroDurationWarning: "0（时长为0，请确认）",
    year: "年",
    month: "个月",
    day: "天",
    hour: "小时",
    minute: "分钟",
    confirmDownload: "确定要下载【{0}】吗？",
    prompt: "提示",
    confirm: "确 定",
    downloadSuccess: "文件下载成功",
    approver: "审批人",
    clickToSign: "点击签字",
    pleaseSignWithMouse: "请使用鼠标签字：",
    clearCanvas: "清空画板",
    confirmSignature: "确认签名",
    signaturePreview: "您的签名预览：",
    addComment: "添加评论",
    submitApproval: "提交审批",
    rejectApproval: "拒绝审批",
    revokeProcess: "撤销当前流程",
    commentContent: "评论内容",
    remark: "备注",
    rejectionReason: "驳回意见",
    revokeReason: "撤销原因",
    pleaseEnterContent: "请输入内容",
    collectedData: "收集到的数据:",
    approvalApproved: "审批同意成功",
    approvalRejected: "审批驳回成功",
    processRevoked: "流程撤销成功",
    commentAdded: "评论添加成功",
    unknownActionType: "未知操作类型",
  },
  upload: {
    selectFile: "选择文件",
    addAttachment: "添加附件",
    singleAttachmentLimit: "单个附件不超过10MB",
    attachmentTooLarge: "附件大小不能超过10MB！",
    fileTooLarge: "文件大小超过最大限制（100MB）",
    uploadSuccess: "文件上传成功",
    uploadFailed: "文件上传失败",
    maxOneAttachment: "最多只能上传1个附件",
    addImage: "添加图片",
    perImageLimit: "每张图不超过10MB",
    imageOnly: "只能是图片格式！",
    imageTooLarge: "上传图片大小不能超过10MB！",
    maxOneImage: "最多只能上传1张图片",
  },
};
